namespace Areas.Event.Edit {
    "use strict";

    export function goToListFromTab() {
        var linkInfo = "/Event/List/Active";
        location.href = linkInfo;
    }

}
